import { SdkParameters } from 'node_modules/onfido-sdk-ui/types/shared/SdkParameters'

function getCssVar(name: string): string | undefined {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim() || undefined
}

export const getOnfidoTheme = (): SdkParameters['theme'] => {
  const onfidoTheme: SdkParameters['theme'] = {
    name: 'light',
    config: {
      fontWeightBody: 400,
      fontSizeBody: '16px',
      fontSizeSubtitle: '16px',
      fontSizeTitle: '40px',
      borderStyleSurfaceModal: 'none',
      colorBackgroundSurfaceModal: getCssVar('--container-bg-color'),
      colorBackgroundIcon: '#e8ebec',

      colorBorderLinkUnderline: getCssVar('--button-bg-color'),
      colorBackgroundLinkActive: 'transparent',
      colorBackgroundLinkHover: 'transparent',
      colorContentLinkTextHover: getCssVar('--link-color-hover'),

      colorContentBody: getCssVar('--container-color'),
      colorContentTitle: getCssVar('--container-color'),
      colorContentSubtitle: getCssVar('--container-color'),

      borderRadiusButton: getCssVar('--button-border-radius'),
      colorContentButtonPrimaryText: getCssVar('--button-color'),
      colorBackgroundButtonPrimary: getCssVar('--button-bg-color'),
      colorBackgroundButtonPrimaryHover: getCssVar('--button-bg-color-hover'),
      colorBackgroundButtonPrimaryActive: getCssVar('--button-bg-color'),

      colorContentButtonSecondaryText: getCssVar('--button-bg-color'),
      colorBorderButtonSecondary: getCssVar('--button-bg-color'),
      colorBackgroundButtonSecondary: getCssVar('--button-secondary-bg-color'),
      colorBackgroundButtonSecondaryHover: getCssVar('--button-secondary-bg-color-hover'),
      colorBackgroundButtonSecondaryActive: getCssVar('--button-secondary-bg-color'),

      colorBorderDocTypeButton: getCssVar('--button-secondary-border'),
      colorBackgroundDocTypeButton: getCssVar('--button-secondary-bg-color'),
      colorBackgroundDocTypeButtonHover: '#e8ebec',
      colorBackgroundDocTypeButtonActive: '#e8ebec',
      colorContentDocTypeButton: getCssVar('--button-secondary-color'),
      colorContentDocTypeButtonHover: getCssVar('--button-secondary-color-hover'),
      colorContentDocTypeButtonActive: getCssVar('--button-secondary-color-hover'),
      colorBorderDocTypeButtonHover: getCssVar('--button-secondary-border-hover'),

      colorIcon: getCssVar('--link-color'),
      colorContentInfoPill: getCssVar('--button-color'),
      colorBackgroundInfoPill: getCssVar('--button-bg-color'),
      colorBackgroundSelector: getCssVar('--text-input-bg-color'),
      colorBackgroundDropdownItemHover: getCssVar('--text-input-bg-color-focus'),
      colorInputOutline: getCssVar('--text-input-border'),
      colorContentButtonTertiaryText: getCssVar('--text-input-color'),
      colorContentInput: getCssVar('--text-input-color'),
      colorBackgroundInput: getCssVar('--text-input-bg-color'),
      colorBorderInput: getCssVar('--text-input-border'),
    },
  }

  return onfidoTheme
}
